"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StylableAggregation = void 0;
var core_1 = require("@stylable/core");
var get_static_computed_css_1 = require("./get-static-computed-css");
var stylable_aggregation_constants_1 = require("./stylable-aggregation-constants");
function matchRegex(selector, matcher) {
    var match = selector.match(matcher);
    return { match: match, name: match ? match[1] : '' };
}
var StylableAggregation = /** @class */ (function () {
    function StylableAggregation(stylableDriver) {
        this.stylableDriver = stylableDriver;
    }
    /**
     * If multiple stylesheet provided we assume that they extending the same Base, we are fully aggregating the base and the variant (deep).
     * !All stylesheets following the first variant will be aggregated from it (shallow).
     * https://jira.wixpress.com/browse/STYL-693?filter=-1
     */
    StylableAggregation.prototype.aggregateSelectorDeclarations = function (sheetPath, selector, filter, useRawDecl, shallow) {
        if (filter === void 0) { filter = stylable_aggregation_constants_1.DEFAULT_FILTER; }
        if (useRawDecl === void 0) { useRawDecl = false; }
        var sheet = this.stylableDriver.getStylesheet(sheetPath);
        if (!sheet) {
            return {};
        }
        var stateName = matchRegex(selector, stylable_aggregation_constants_1.SELECTOR_STATE_REGEX).name;
        // TODO: this is work around issue for when to filter -st- stuff related to states (should be removed)
        var filterDecl = stateName
            ? function (prop) { return prop !== core_1.valueMapping.extends && prop !== core_1.valueMapping.states && filter(prop); }
            : filter;
        try {
            return get_static_computed_css_1.getStaticComputedCSS(this.stylableDriver.stylable, sheet.getMeta(), selector, {
                filterDecl: filterDecl,
                scopes: sheet.getActiveScopes(),
                useRawDecl: useRawDecl,
                shallow: shallow,
            }).decls;
        }
        catch (e) {
            throw new Error('getStaticComputedCSS error caused by:\n' + e.stack);
        }
    };
    return StylableAggregation;
}());
exports.StylableAggregation = StylableAggregation;
//# sourceMappingURL=stylable-aggregation.js.map